module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/tank-not-available.273bdb05.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/tank-not-available.png
// module id = 970
// module chunks = 16